import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Flex, Text } from 'onefaceui-react-components';

import progressNumbersHelper from 'react/api/dto/ProgressNumbers';

import StatusIcon from './StatusIcon';
import Label from './Label';
import ProgressBar from './ProgressBar';
import RouteDate from './RouteDate';
import DetailedTooltip from './DetailedTooltip';

function RouteInfo({ route: routeView }) {
  const { route } = routeView;

  const [styles, setStyles] = useState({
    backgroundColor: 'transparent',
    transform: '-90',
    display: 'none',
    clientX: 0,
    clientY: 0
  });

  const showTooltip = useCallback((event) => {
    const {
      clientX,
      clientY,
      currentTarget: { offsetLeft }
    } = event;

    setStyles((prev) => ({
      ...prev,
      display: 'flex',
      clientX: clientX - offsetLeft,
      clientY
    }));
  }, []);

  const hideTooltip = useCallback(() => {
    setStyles((prev) => ({
      ...prev,
      display: 'none'
    }));
  }, []);

  const progressNumbers = useMemo(
    () => progressNumbersHelper(routeView),
    [routeView]
  );

  const { progressText } = progressNumbers;

  return (
    <Flex justifyContent="space-between" style={{ flex: 1 }}>
      <div className="routeInfo">
        <StatusIcon routeView={routeView} />
        <Flex gap={4} flexDirection="column" style={{ flex: 1 }}>
          <Flex
            alignItems="center"
            justifyContent="space-between"
            className="key-and-progress"
          >
            <Label routeView={routeView} />
            <Text size="xs" weight="bold">
              {progressText}
            </Text>
          </Flex>
          <ProgressBar
            routeId={route.id}
            progressNumbers={progressNumbers}
            onMouseOver={showTooltip}
            onMouseOut={hideTooltip}
            onMouseMove={showTooltip}
          />
          <RouteDate route={route} />
        </Flex>
      </div>
      <DetailedTooltip {...styles} progressNumbers={progressNumbers} />
    </Flex>
  );
}

RouteInfo.propTypes = {
  route: PropTypes.object.isRequired
};

export default RouteInfo;
